export default __webpack_public_path__ + "static/media/digit.9de7bf9f.svg";